function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.35685 0 0 3.35685 0 7.5C0 11.6431 3.35685 15 7.5 15C11.6431 15 15 11.6431 15 7.5C15 3.35685 11.6431 0 7.5 0ZM11.1774 9.46875C11.3196 9.61089 11.3196 9.84073 11.1774 9.98286L9.97984 11.1774C9.8377 11.3196 9.60786 11.3196 9.46573 11.1774L7.5 9.19355L5.53125 11.1774C5.38911 11.3196 5.15927 11.3196 5.01714 11.1774L3.82258 9.97984C3.68044 9.8377 3.68044 9.60786 3.82258 9.46573L5.80645 7.5L3.82258 5.53125C3.68044 5.38911 3.68044 5.15927 3.82258 5.01714L5.02016 3.81956C5.1623 3.67742 5.39214 3.67742 5.53427 3.81956L7.5 5.80645L9.46875 3.82258C9.61089 3.68044 9.84073 3.68044 9.98286 3.82258L11.1804 5.02016C11.3226 5.1623 11.3226 5.39214 11.1804 5.53427L9.19355 7.5L11.1774 9.46875Z",
  fill: "black"
});

var SvgDeclineCircle = function SvgDeclineCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeclineCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/decline-circle.6ca5ed06.svg";
export { ForwardRef as ReactComponent };